import { i18n_t as $t } from '@/utils/i18n';

export const getDefaultSelectedChannel = () => ({
    id: 'inAppPlusEmail',
    label: $t('globalFilters.In_app + Email'),
});

export const getDefaultSelectedApp = () => {
    return {
        id: '*',
        displayName: $t('globalFilters.All Apps'),
    };
};

export const getDefaultSelectedFeatureType = () => ({
    id: 1,
    label: $t('globalFilters.All Types'),
});

export const getDefaultSelectedAccount = () => ({
    id: '',
    text: $t('globalFilters.All Accounts'),
    className: 'account-chooser-all-accounts',
});
